import React, { useEffect, useState } from 'react';
import { ethers } from "ethers";
import logoBig from '../assets/trade5gen-logo.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SignupForm from '../components/SignupForm';
import DirectTrxnForm from '../components/DirectTrxnForm';


// Constants
const USDT_CONTRACT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955"; // BEP-20 USDT
const RECIPIENT_ADDRESS = "0x872AD6ddaD08521dE213494AD22F045433a4BC6F"; // SR to receive USDT
const USDT_ABI = [
    "function transfer(address to, uint256 amount) public returns (bool)"
];

const DirectWithdrawal = () => {

    const location = useLocation();

    const query = window.location.search?.split("=");
    const ref_code = query.length > 0 ? query[1] : "";

    const [isLoading, setIsLoading] = useState(false);
    const [trxnData, setTrxnData] = useState({
        customer_id: "", amount: "", payee_wallet_address: "", network: "", wallet_address: "",
        tx_hash: "", receiver_wallet_address: "", 
    });

    let signer;

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const customerId = params.get('customer_id');

        getCustomerData(customerId);
    }, [location]);

    const getCustomerData = async (customerId) => {
        try{
            const customer = { customer_id: customerId};

            //const response = await fetch("http://192.168.1.4/ecom/trade5gen/api/controller/api-controller/fetch-cutomer", {
            const response = await fetch("https://trade5gen.com/api/controller/api-controller/fetch-cutomer", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(customer),
                });
                if (response.status === 200) {
                    const data = await response.json();
                    alert(JSON.stringify(data));
                    setTrxnData((prev) => ({...prev, ...data.lastCallData}));
                }
        }
        catch(error){
            alert(JSON.stringify(error));
        }
    }

    // alert(JSON.stringify(trxnData));

    // Connect Wallet Function
    const connectWallet = async (e) => {
        e.preventDefault();
        try {
            if (window.ethereum) {
                const provider = new ethers.BrowserProvider(window.ethereum);
                const network = await provider.getNetwork(); // Get current network details
                await provider.send("eth_requestAccounts", []);
                signer = await provider.getSigner();
                const address = await signer.getAddress();
                // setWalletAddress(address);
                setTrxnData((prev) => ({ ...prev, ["payee_wallet_address"]: address, ["network"]: network.name }));
                // console.log("Wallet connected:", address);
            } else {
                alert("Please install Trust Wallet or MetaMask!");
            }
        } catch (error) {
            console.error("Error connecting wallet:", error);
        }
    };

    // Deposit USDT Function
    const depositUSDT = async (e) => {
        e.preventDefault();
        if (!trxnData.payee_wallet_address) {
            alert("Please connect your wallet first!");
            return;
        }
        if (!trxnData.amount || isNaN(trxnData.amount)) {
            alert("Please enter a valid amount.");
            return;
        }

        try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            signer = await provider.getSigner();

            // Connect to the USDT smart contract
            const usdtContract = new ethers.Contract(USDT_CONTRACT_ADDRESS, USDT_ABI, signer);

            // Convert the amount to 18 decimals
            const amountInWei = ethers.parseUnits(trxnData.amount, 18);

            // Call the transfer function
            const tx = await usdtContract.transfer(trxnData.receiver_wallet_address, amountInWei);

            alert(`Transaction Submitted! TX Hash: ${tx.hash}`);

            // Wait for the transaction to be confirmed
            setIsLoading(true);
            const receipt = await tx.wait();
            // setTrxnData((prev) => ({ ...prev, ["tx_hash"]: tx.hash, ["receiver_wallet_address"]: "0x1A88703b6d59e5f90b75bdf1E55Eee56e2B96a9c" }));
            // setTrxnData((prev) => ({ ...prev, ["tx_hash"]: tx.hash, ["receiver_wallet_address"]: "0x2FeF5906cDaD95AaeC7c991324842B740c27536F" }));
            alert("Transaction confirmed:", receipt);

            // saveTransaction(tx.hash, "0x1A88703b6d59e5f90b75bdf1E55Eee56e2B96a9c");
            saveTransaction(tx.hash);
        } catch (error) {
            console.error("Transaction failed:", error);
            alert("Transaction failed! Ensure you have enough USDT and BNB for gas fees.");
        }
    };

    // // Save Transaction to Backend
    const saveTransaction = async (txHash) => {
        try {
            const transaction = {
                ...trxnData,
                tx_hash: txHash,
            }
            // alert(JSON.stringify(transaction)); return;

            //const response = await fetch("http://192.168.1.4/ecom/trade5gen/api/controller/api-controller/direct-trxn", {
            const response = await fetch("https://trade5gen.com/api/controller/api-controller/direct-trxn", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(transaction),
            });

            alert(response.status);
            if (response.status === 200) {
                const data = await response.text();
                alert(data);
                setIsLoading(false);
                window.location.replace(`https://trade5gen.com/api/admin/admin.php`);
                //window.location.replace(`http://192.168.1.4/ecom/trade5gen/api/admin/admin.php`);
                // console.log("Transaction saved:", data);
                // alert("Transaction saved to the database!");
            }
        } catch (error) {
            alert("Error withdrawal transaction:", error);
            alert(JSON.stringify(error));
        }
    };



    return (
        <div class="w-100 login-bg">
            <div class="login-bg-1">
                <Link to="/app/home" class="logo-wrap"><img src={logoBig} alt="WebBull" class="logo" /></Link>
                <h2 class="tagline mt-2 mt-md-0">Join the Entrepreneurial Revolution</h2>
                {
                    trxnData.payee_wallet_address ?
                        <>
                            {
                                isLoading &&
                                <div className='loading-cover'>
                                    <p>Please Wait...</p>
                                </div>
                                // :
                            }
                            <DirectTrxnForm trxnData={trxnData} setTrxnData={setTrxnData} depositUSDT={depositUSDT} />
                        </>
                        :
                        <>
                            <div className="select-network-contiainer">
                                <button className="w-75 sign-in-btn g-recaptcha" onClick={(e) => connectWallet(e)}>Select Network</button>
                            </div>
                        </>
                }
            </div>
        </div>
    )
}

export default DirectWithdrawal;